import { css } from 'styled-components'

export const flex = (flexDirection?: string, flexSize?: number) => css`
    display: flex;
    flex-direction: ${flexDirection || 'column'};
    flex: ${flexSize || 1};
`

export const flexAlign = (justifyContent?: string, alignItems?: string) => css`
    ${() => justifyContent && css`justify-content: ${justifyContent};`}
    ${() => alignItems && css`align-items: ${alignItems};`}
`

export const overflowLimitTo = (size?: number) => css`
    display: block;
    max-width: ${size}px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
`
